// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__Vu6sa","title":"Notifications_title__xFVOt","viewMore":"Notifications_viewMore__h-UJd"};